//Provider wrapper at - src/index.js
import { useState, useEffect, createContext } from "react";

export const Context = createContext();

const crypto = require('crypto');

function ContextProvider(props) {

    const authToken = localStorage.getItem("authToken");
    const ApiURL = window.Links.ApiURL;

    const [fieldManager, setFieldManager] = useState({});
    const [isHeadOffice, setIsHeadOffice] = useState(false);
    const [endOfDate, setEndOfDate] = useState("");
    const [txnDecimalAmt, setTxnDecimalAmt] = useState(2);
    const [txnDecimalQty, setTxnDecimalQty] = useState(2);
    const [passwordpolicy, setPasswordpolicy] = useState(""); //password policy
    const [passwordPolicyDescription, setPasswordPolicyDescription] = useState(""); //password policy description
    const [setupLocation, setSetupLocation] = useState(""); //setup location
    const [cashbokDate, setCashbookDate] = useState(""); //last cashbook date
    const [pluRef1, setPluRef1] = useState(""); //product reference 1
    const [pluRef2, setPluRef2] = useState(""); //product reference 2
    const [pluRef3, setPluRef3] = useState(""); //product reference 3
    const [pluRef4, setPluRef4] = useState(""); //product reference 4
    const [pluRef5, setPluRef5] = useState(""); //product reference 5
    const mobileNumberRegexp = /^(?:0|94|\+94)?(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    const emailRegexp = /^[a-z0-9._%+-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z0-9-]+\.)+[a-z]{2,}))$/;


    const [CurrentMoth, setCurrentMoth] = useState("");
    const [CurrentYear, setCurrentYear] = useState("");
    const [approvalNotifications, setApprovalNotifications] = useState([]);
    const [useEffecttrigger, setUseEffecttrigger] = useState(false);
    const [menus, setMenus] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [isHeadOfficeURL, setIsHeadOfficeURL] = useState(false)
    const [posGroupLevel, setPosGroupLevel] = useState(0)
    const [isWMS, setIsWMS] = useState(false)
    const [calGP_WithTAX, setCalGP_WithTAX] = useState(false)
    const [validate_groups, setValidate_groups] = useState(0)
    const [default_markup, setDefault_markup] = useState(0)
    const [excludefrom_productreset, setExcludefrom_productreset] = useState(0)
    const [proSup_default_loc, setProSup_default_loc] = useState("")
    const [ledger_creditdebit_diffrence, setLedger_creditdebit_diffrence] = useState(0)
    const [validateCustomerNIC, setValidateCustomerNIC] = useState(0)
    const [validateWeighted_VS_MP, setValidateWeighted_VS_MP] = useState(0)
    const [validateProductImage, setValidateProductImage] = useState(0)


    //initial run
    useEffect(() => {
        if (window.location.pathname == "/login") return
        getSetupDetailsContext();
        getCashBookDate();
        getCommonNotifications();
    }, [])

    useEffect(() => {
        if (window.location.pathname == "/login") return
        getNotificationApprovels();
    }, [useEffecttrigger])

    //Get Non-Editable Fields
    async function getNonEditable(menuCode) { //get non editable fields from edit table
        var menu = menuCode;

        if (menu == null || menu == undefined || menu == '') return

        var requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        await fetch(`${ApiURL}Common/edit/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {

                if (result.success) {
                    var dt = result.data[0]
                    var newlist = dt != "" ? dt.strEditFeild.split(",") : []
                    var hiddenFields = dt.edt_hidefields;

                    var fieldManagerUpdated = { ...fieldManager }
                    fieldManagerUpdated[menu.toString()] = {
                        disable: newlist,
                        hidden: hiddenFields
                    }
                    setFieldManager(fieldManagerUpdated);
                } else {
                    var fieldManagerUpdated = { ...fieldManager }
                    fieldManagerUpdated[menu.toString()] = {
                        disable: [],
                        hidden: []
                    }
                    setFieldManager(fieldManagerUpdated);
                }


            }).catch(error =>
                console.log('ERROR', error)
            );
    }


    async function getSetupDetailsContext() {
        const authToken1 = localStorage.getItem("authToken");
        const ApiURL1 = window.Links.ApiURL;

        var requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken1}`
            },
            redirect: 'follow'
        };

        try {
            const response = await fetch(`${ApiURL1}SetupDet/setupDet`, requestOptions);

            if (response.status === 200) {
                const result = await response.json();
                var dt = result.data[0];

                setIsHeadOffice(dt.isHeadOffice);
                setCurrentMoth(dt.currentMonth);
                setCurrentYear(dt.currentYear);
                setEndOfDate(dt.endOfDate.slice(0, 10));
                setTxnDecimalAmt(dt.txnDecimalAmt);
                setTxnDecimalQty(dt.txnDecimalQty);
                setPasswordpolicy(dt.passwordPolicy == "" ? "^[\w\d\s\S]*$" : dt.passwordPolicy);
                setPasswordPolicyDescription(dt.passwordPolicyDescription);
                setSetupLocation(dt.locationcode);
                setPluRef1(dt.pluRef1);
                setPluRef2(dt.pluRef2);
                setPluRef3(dt.pluRef3);
                setPluRef4(dt.pluRef4);
                setPluRef5(dt.pluRef5);
                setPosGroupLevel(dt.setuP_POS_GROUP_LEVEL);
                setIsWMS(dt.isWMS);
                setCalGP_WithTAX(dt.calGP_WithTAX == 1 ? true : false);
                setValidate_groups(dt.validate_groups);
                setDefault_markup(parseFloat(dt.default_markup) > 100 ? 0 : parseFloat(dt.default_markup));
                setExcludefrom_productreset(dt.excludefrom_productreset)
                setProSup_default_loc(dt.proSup_default_loc)
                setLedger_creditdebit_diffrence(dt.setLedger_creditdebit_diffrence)
                setValidateCustomerNIC(dt.validateCustomerNIC)
                setValidateWeighted_VS_MP(dt.validateWeighted_VS_MP)
                setValidateProductImage(dt.validateProductImage)
            } else {
                console.log('Response Error: ', response.status, response.statusText);
            }
        } catch (error) {
            console.log('Fetch Error: ', error);
        }
    }



    async function getNotificationApprovels() { //transaction notification approvals for user

        var obj = JSON.parse(localStorage.getItem("authUser"))

        if (obj == null || obj == undefined) return

        var LogUserType = obj[2]
        var LocationCode = obj[3]

        var requestOptions = {
            method: 'GET',
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        };

        fetch(`${ApiURL}remote/notifications/${LogUserType}/${LocationCode}`, requestOptions)
            .then(async (response) => response.json())
            .then(result => {
                setApprovalNotifications(result.data)
            }).catch(error =>
                console.log('error', error)
            );

    }



    async function getMenuDetails(url) {
        var obj = JSON.parse(localStorage.getItem("authUser"));
        if (!obj) return { parentName: "", menuTag: "" };

        var LogUserType = obj[2];

        // Use the current menus if available instead of reloading
        let currentMenus = menus;
        
        // Only reload if menus are empty
        if (currentMenus.length === 0) {
            currentMenus = await ReloadMenu(LogUserType);
        }

        const foundMenu = currentMenus
            .filter(menu => menu.strMenuName != "Favourite")
            .find(menu => menu.lstChildren.find(childMenu => childMenu.strUrl === url));

        if (foundMenu) {
            const parentName = foundMenu.strMenuName;
            const menuTag = foundMenu.lstChildren.find(childMenu => childMenu.strUrl === url).strMenuTag;
            return { parentName, menuTag };
        }

        return { parentName: "", menuTag: "" };
    }

    async function getCommonNotifications() { //get notifications for common notifications

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var user = obj[2]

        fetch(`${ApiURL}common/notification/${user}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        })
            .then(Response => Response.json())
            .then(responseData => {
                setNotifications(responseData.data)
            }).catch(error => {
                console.log('error', error)
            })
    }




    async function masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) {

        const AuditLog = {
            "strMenuCode": menu,
            "strUserName": LogUserType,
            "strLocCode": LocationCode,
            "strComcode": CompanyCode,
            "strReason": ""
        }

        var requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(AuditLog),
        };

        fetch(`${ApiURL}login/menu/audit`, requestOptions)
            .then(async (response) => await response.json())
            .then(result => {
                console.log(result)
            }).catch(error =>
                console.log('error', error)
            );
    }


    async function getSelectedMasterPermissions(LogUserType, menuCode) {

        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                redirect: 'follow'
            };

            const encodedUName = encodeURIComponent(LogUserType);
            const encodedMenuCode = encodeURIComponent(menuCode);

            const response = await fetch(`${ApiURL}login/menu/${encodedUName}/${encodedMenuCode}`, requestOptions);
            const result = await response.json();
            const responseData = result.data;

            return responseData;
        } catch (error) {
            console.log('Error:', error);
            throw error;
        }
    }

    async function fetchAutoCode(menu) {
        try {
            const response = await fetch(`${ApiURL}common/autocode/${menu}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`,
                },
            });

            const responseData = await response.json();

            if (responseData.success) {
                if (responseData.data.length === 0) {
                    return { nullCode: true, autoCode: null };
                } else {
                    return { nullCode: false, autoCode: responseData.data };
                }
            } else {
                return { nullCode: true };
            }
        } catch (error) {
            console.log("Error:", error);
            throw error;
        }
    }



    async function fetchProductAutoCode(menu) {

        const obj = JSON.parse(localStorage.getItem("authUser"))
        const user = obj[2]
        const location = obj[3]

        try {
            const response = await fetch(`${ApiURL}common/autocode`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    menuCode: menu,
                    user,
                    location
                }),
            });

            const responseData = await response.json();

            if (responseData.success) {
                if (responseData.data.length === 0) {
                    return { nullCode: true, autoCode: null };
                } else {
                    return { nullCode: false, autoCode: responseData.data };
                }
            } else {
                return { nullCode: true };
            }
        } catch (error) {
            console.log("Error:", error);
            throw error;
        }
    }



    async function MenuUserpermission(detailPermissionUsername, detailPermissionPassword, menuCode, permissionCode) {

        try {

            var obj = JSON.parse(localStorage.getItem("authUser"))
            var LocationCode = obj[3]

            const permissiondata = {
                strUsername: detailPermissionUsername,
                strPassword: detailPermissionPassword,
                strLocation: LocationCode,
                strMenuCode: menuCode,
            }

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(permissiondata),
            }

            const response = await fetch(`${ApiURL}login/userpermission`, requestOptions)
            const result = await response.json();
            const responseData = result.data;

            return responseData;
        } catch (error) {
            console.log(error.message)
        }

    }



    async function getCashBookDate() {

        try {
            const response = await fetch(`${ApiURL}CashBook/getcashbookdate`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`,
                },
            });

            const responseData = await response.json();

            if (responseData.success) {
                setCashbookDate(responseData.data)
            } else {
                setCashbookDate("")
            }
        } catch (error) {
            console.log("Error:", error);
            throw error;
        }
    }


    async function addtoFavourite(menuCode, LogUserType) {

        try {
            const ApiURL = window.Links.ApiURL;
            const authToken = localStorage.getItem("authToken");

            const requestOptions = {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify({ menuCode, LogUserType })
            };

            const response = await fetch(`${ApiURL}common/addtofavourite`, requestOptions);

            const result = await response.json();
            if (!result.success) {

                return { success: false, data: result.data, message: result.message };
            }
            ReloadMenu(LogUserType)
            return { success: true, data: result.data, message: result.message };
        } catch (error) {
            console.error("AddToFavourite error:", error);
            //throw error; // Rethrow the error to be handled by the caller
        }
    };

    async function ReloadMenu(userName) {

        try {
            const ApiURL = window.Links.ApiURL;
            const authToken = localStorage.getItem("authToken");

            const requestOptions = {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
            };

            const response = await fetch(`${ApiURL}login/menu/${userName}`, requestOptions);
            const result = await response.json();

            if (result.success) {
                const newMenus = result.data.filter(menu => menu.strMenuTag != "" && menu.strMenuTag != null);
                setMenus(newMenus);
                return newMenus;
            } else {
                setMenus([]);
                return [];
            }
        } catch (error) {
            console.error("ReloadMenu error:", error);
        }
    }



    async function FetchUserGroups(requestOptions) {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        try {
            const response = await fetch(`${ApiURL}Common/RemoteAccept`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(requestOptions)
            });

            const responseData = await response.json();

            if (responseData.success) {
                return { success: true, data: responseData.data.map(item => item['userGroup']), message: responseData.msg };
            }
            return { success: false, data: [], message: responseData.msg };
        } catch (error) {
            console.log(error);
            return { success: false, data: [], message: error };
        }
    }



    async function FetchPortID() {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");


        try {
            const response = await fetch(`${ApiURL}Common/GetPortID`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                }
            });

            const responseData = await response.json();

            if (responseData.success) {
                return { success: true, data: responseData.data, message: responseData.msg };
            }

            return { success: false, data: "", message: responseData.msg };
        } catch (error) {
            console.log(error);
            return { success: false, data: "", message: error };
        }
    }


    async function sendApprovalNotification(portID, object) {

        const myAlertURL = window.Links.MyAlertUrl;
        const authToken = localStorage.getItem("authToken"); 1

        try {
            const response = await fetch(`${myAlertURL}notification/approval`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(object)
            });

            const responseData = await response.json();
        } catch (error) {
            console.log(error);
        }
        return true;
    }




    async function PublishMessage(universalID, requestedDateTime) {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        // Create a new AbortController instance
        const controller = new AbortController();
        const signal = controller.signal;  // Get the signal from the controller

        try {
            const response = await fetch(`${ApiURL}Longpoling/PublishMessage`, {
                method: "POST",
                signal,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify({
                    "header": {
                        "messageId": universalID,
                        "requestedDateTime": requestedDateTime,
                        "requested": true,
                        "processed": false
                    },
                    "body": {
                        "deviceToken": "",
                        "reason": "",
                        "uuID": "",
                        "permission": "",
                        "menucode": "",
                        "right": ""
                    }
                })
            });

            const responseData = await response.json();

            if (responseData.data && responseData.data.status !== 0 && responseData.data.body !== null) {
                return { success: true, data: responseData.data.body };
            }
            return { success: false, data: "" };
        } catch (error) {
            console.log(error);
            return { success: false, data: "" };
        }

    }



    async function FetchDeviceUserDetails(deviceToken) {

        try {
            const response = await fetch(`${ApiURL}Common/DeviceUser/${deviceToken}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
            });

            const responseData = await response.json();

            if (responseData.success) {
                return { success: true, data: responseData.data, message: responseData.msg };
            }

            return { success: false, data: "", message: responseData.msg };
        } catch (error) {
            console.log(error);
            return { success: false, data: "", message: error };
        }
    }





    const values = {
        fieldManager, getNonEditable,
        isHeadOffice, approvalNotifications, setUseEffecttrigger,
        menus, setMenus, getMenuDetails, getCommonNotifications, notifications,
        CurrentMoth, CurrentYear, endOfDate, txnDecimalAmt, txnDecimalQty,
        passwordpolicy, passwordPolicyDescription, setupLocation, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode,
        MenuUserpermission, getSetupDetailsContext, cashbokDate, setIsHeadOfficeURL, isHeadOfficeURL, addtoFavourite, mobileNumberRegexp, emailRegexp,
        FetchUserGroups, FetchPortID, sendApprovalNotification, PublishMessage, FetchDeviceUserDetails, pluRef1, pluRef2, pluRef3, pluRef4, pluRef5, posGroupLevel,
        isWMS, calGP_WithTAX, validate_groups, default_markup, excludefrom_productreset, proSup_default_loc, ledger_creditdebit_diffrence, fetchProductAutoCode, validateCustomerNIC,
        validateWeighted_VS_MP, validateProductImage

    }


    return (
        <Context.Provider value={values}>
            {props.children}
        </Context.Provider>
    )
}

export default ContextProvider;